export default __webpack_public_path__ + "static/Objective-Bold-42e3a0d2f71b49e99c32ea2a8f00e8aa.otf";